import { useNavigation } from '@react-navigation/native';
import { CRM_TYPES, CXTabBarContext } from 'components/organisms/CXTabBar/cx-tab-bar-context';
import { OpportunityScreens } from 'domain/opportunity-list/screens';
import { CLOSED_SESSIONS, ACTIVE_SESSION } from 'domain/shared/screens';
import { getCurrentRouteName } from 'domain/shared/services/navigation-service';
import React, { useContext, useEffect } from 'react';
import { ActivityIndicator } from 'react-native';
import Sentry from 'sentry';
import styled from 'styled-components/native';
import colors from 'theme/colors';

const Container = styled.View`
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${colors.WHITE};
`;

export default function ChromeExtension() {
  const { setTabBarVisible, CRMhost } = useContext(CXTabBarContext);
  const navigation = useNavigation();

  useEffect(() => {
    if (CRMhost === CRM_TYPES.vin) {

      /**
       * We found a intersiting issue application was getting stuck in here
       * So to avoid it we are sending the user to 
       */
      const time = setTimeout(function () {
        const name = getCurrentRouteName()
        if (name == OpportunityScreens.CHROME_EXTENSION) {
          Sentry.captureException(new Error("Application got stuck and we force send to HUB"))
          navigation.navigate(CLOSED_SESSIONS as never)
          setTabBarVisible(true)
        }
        clearTimeout(time)
      }, 5000)
    }

    setTabBarVisible(false);
    return () => {
      setTabBarVisible(true);
    };
  }, []);

  return (
    <Container>
      <ActivityIndicator
        size="large"
        color={colors.ORANGE}
        animating
        style={{ minHeight: 50 }}
      />
    </Container>
  );
}
